// extracted by extract-css-chunks-webpack-plugin
module.exports = {"main_nav":"main_nav-B8Qh7-Hz","user":"user-3mfy7BVO","box":"box-6I_IpHVn","ad":"ad-1bIsE0Zj","search":"search-216OWLze","logo":"logo-2RDCNmBC"};